import { ServiceFetch } from '../service-fetch'

export default class PayrollListModel extends ServiceFetch {
    getPayrollListBy = (data) => this.authFetch({
        url: 'payroll-list/getPayrollListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}